module.exports = __webpack_public_path__ + "static/assets/9ad3a724c00a5db5c90b87852d7da499.png";